var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "unit_group mr-2 ml-1" },
    [
      _c(
        "div",
        {
          directives: [
            { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
          ],
        },
        [
          _c("div", {
            directives: [
              {
                name: "pui-form-grid-column",
                rawName: "v-pui-form-grid-column",
                value: { s: 12, l: 3 },
                expression: "{ s: 12, l: 3}",
              },
            ],
          }),
          _c("div", {
            directives: [
              {
                name: "pui-form-grid-column",
                rawName: "v-pui-form-grid-column",
                value: { s: 12, l: 1 },
                expression: "{ s: 12, l: 1}",
              },
            ],
          }),
          _c(
            "div",
            {
              directives: [
                {
                  name: "pui-form-grid-column",
                  rawName: "v-pui-form-grid-column",
                  value: { s: 12, l: 4 },
                  expression: "{ s: 12, l: 4}",
                },
              ],
              staticClass: "center",
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "operationalData.entryView.tabs.qualityLossesTab.table.monthlyActual"
                    )
                  ) +
                  " "
              ),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "pui-form-grid-column",
                  rawName: "v-pui-form-grid-column",
                  value: { s: 12, l: 4 },
                  expression: "{ s: 12, l: 4}",
                },
              ],
              staticClass: "center",
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "operationalData.entryView.tabs.qualityLossesTab.table.monthlyForecast"
                    )
                  ) +
                  " "
              ),
            ]
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
          ],
          staticClass: "row; mt-1 mb-1 mr-2 ml-1",
          attrs: { id: "waterTemperatureRow" },
        },
        [
          _c(
            "pui-form-group",
            {
              directives: [
                {
                  name: "pui-form-grid-column",
                  rawName: "v-pui-form-grid-column",
                  value: { s: 12, l: 3 },
                  expression: "{ s: 12, l: 3}",
                },
              ],
              attrs: {
                label: _vm.$t(
                  "operationalData.entryView.tabs.qualityLossesTab.table.avgCoolWater"
                ),
                "has-info-layer": true,
                "pui-popover-config": {
                  headline: this.$t(
                    "operationalData.entryView.tabs.qualityLossesTab.table.avgWaterInfoTitle"
                  ),
                  position: "bottom",
                },
              },
            },
            [
              _c(
                "p",
                {
                  attrs: { slot: "pui-popover-content" },
                  slot: "pui-popover-content",
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        this.$t(
                          "operationalData.entryView.tabs.qualityLossesTab.table.avgWaterInfo"
                        )
                      ) +
                      " "
                  ),
                ]
              ),
            ]
          ),
          _c("div", {
            directives: [
              {
                name: "pui-form-grid-column",
                rawName: "v-pui-form-grid-column",
                value: { s: 12, l: 1 },
                expression: "{ s: 12, l: 1}",
              },
            ],
          }),
          _c(
            "div",
            {
              directives: [
                {
                  name: "pui-form-grid-column",
                  rawName: "v-pui-form-grid-column",
                  value: { s: 12, l: 4 },
                  expression: "{ s: 12, l: 4}",
                },
              ],
              staticClass: "btn_center",
            },
            [
              _c("custom-input", {
                attrs: {
                  "is-disabled": _vm.isReadOnly,
                  required: false,
                  precision: _vm.qualityLossesPrecision,
                },
                on: {
                  change: function ($event) {
                    return _vm.atInputChangeTemp(_vm.qualityLossesTemp)
                  },
                },
                model: {
                  value: _vm.qualityLossesTemp.waterActual,
                  callback: function ($$v) {
                    _vm.$set(_vm.qualityLossesTemp, "waterActual", $$v)
                  },
                  expression: "qualityLossesTemp.waterActual",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "pui-form-grid-column",
                  rawName: "v-pui-form-grid-column",
                  value: { s: 12, l: 4 },
                  expression: "{ s: 12, l: 4}",
                },
              ],
              staticClass: "btn_center",
            },
            [
              _c("custom-input", {
                attrs: {
                  "is-disabled": _vm.isReadOnly,
                  required: false,
                  precision: _vm.qualityLossesPrecision,
                },
                on: {
                  change: function ($event) {
                    return _vm.atInputChangeTemp(_vm.qualityLossesTemp)
                  },
                },
                model: {
                  value: _vm.qualityLossesTemp.waterForecast,
                  callback: function ($$v) {
                    _vm.$set(_vm.qualityLossesTemp, "waterForecast", $$v)
                  },
                  expression: "qualityLossesTemp.waterForecast",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.isGT
        ? _c(
            "div",
            {
              directives: [
                { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
              ],
              staticClass: "row; mt-1 mb-1 mr-2 ml-1",
              attrs: { id: "airTemperatureRow" },
            },
            [
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, l: 3 },
                      expression: "{ s: 12, l: 3}",
                    },
                  ],
                  attrs: {
                    label: _vm.$t(
                      "operationalData.entryView.tabs.qualityLossesTab.table.avgAirTemp"
                    ),
                    "has-info-layer": true,
                    "pui-popover-config": {
                      headline: this.$t(
                        "operationalData.entryView.tabs.qualityLossesTab.table.avgAirInfoTitle"
                      ),
                      position: "bottom",
                    },
                  },
                },
                [
                  _c(
                    "p",
                    {
                      attrs: { slot: "pui-popover-content" },
                      slot: "pui-popover-content",
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            this.$t(
                              "operationalData.entryView.tabs.qualityLossesTab.table.avgAirInfo"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]
              ),
              _c("div", {
                directives: [
                  {
                    name: "pui-form-grid-column",
                    rawName: "v-pui-form-grid-column",
                    value: { s: 12, l: 1 },
                    expression: "{ s: 12, l: 1}",
                  },
                ],
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, l: 4 },
                      expression: "{ s: 12, l: 4}",
                    },
                  ],
                  staticClass: "btn_center",
                },
                [
                  _c("custom-input", {
                    attrs: {
                      "is-disabled": _vm.isReadOnly,
                      required: false,
                      precision: _vm.qualityLossesPrecision,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.atInputChangeTemp(_vm.qualityLossesTemp)
                      },
                    },
                    model: {
                      value: _vm.qualityLossesTemp.airActual,
                      callback: function ($$v) {
                        _vm.$set(_vm.qualityLossesTemp, "airActual", $$v)
                      },
                      expression: "qualityLossesTemp.airActual",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, l: 4 },
                      expression: "{ s: 12, l: 4}",
                    },
                  ],
                  staticClass: "btn_center",
                },
                [
                  _c("custom-input", {
                    attrs: {
                      "is-disabled": _vm.isReadOnly,
                      required: false,
                      precision: _vm.qualityLossesPrecision,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.atInputChangeTemp(_vm.qualityLossesTemp)
                      },
                    },
                    model: {
                      value: _vm.qualityLossesTemp.airForecast,
                      callback: function ($$v) {
                        _vm.$set(_vm.qualityLossesTemp, "airForecast", $$v)
                      },
                      expression: "qualityLossesTemp.airForecast",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
          ],
          staticClass: "row mt-3 mb-1",
        },
        [
          _c(
            "pui-form-group",
            {
              directives: [
                {
                  name: "pui-form-grid-column",
                  rawName: "v-pui-form-grid-column",
                  value: { s: 12, l: 4 },
                  expression: "{ s: 12, l: 4}",
                },
              ],
              attrs: {
                label: this.$t(
                  "operationalData.entryView.tabs.qualityLossesTab.percentages.opInternal"
                ),
              },
            },
            [
              _c("custom-input", {
                attrs: {
                  id: "customInputOpInternal",
                  min: 0,
                  max: 100,
                  "is-disabled": _vm.isReadOnly,
                  required: false,
                  precision: _vm.qualityLossesPrecision,
                },
                on: {
                  change: function ($event) {
                    return _vm.atInputChangePct(_vm.qualityLossesPct)
                  },
                },
                model: {
                  value: _vm.qualityLossesPct.valueInternal,
                  callback: function ($$v) {
                    _vm.$set(_vm.qualityLossesPct, "valueInternal", $$v)
                  },
                  expression: "qualityLossesPct.valueInternal",
                },
              }),
              _c("pui-form-textarea", {
                staticClass: "mt-1",
                attrs: {
                  id: "customCommentInternal",
                  "is-readonly": false,
                  "is-disabled": _vm.isReadOnly,
                  "max-length": _vm.maxInputLength,
                  grow: false,
                  rows: 8,
                },
                on: {
                  input: function ($event) {
                    return _vm.atInputChangePct(_vm.qualityLossesPct)
                  },
                },
                model: {
                  value: _vm.qualityLossesPct.commentInternal,
                  callback: function ($$v) {
                    _vm.$set(_vm.qualityLossesPct, "commentInternal", $$v)
                  },
                  expression: "qualityLossesPct.commentInternal",
                },
              }),
              _c("div", { staticClass: "right" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.commentLength(this.qualityLossesPct.commentInternal)
                    ) +
                    "/250 "
                ),
              ]),
            ],
            1
          ),
          _c(
            "pui-form-group",
            {
              directives: [
                {
                  name: "pui-form-grid-column",
                  rawName: "v-pui-form-grid-column",
                  value: { s: 12, l: 4 },
                  expression: "{ s: 12, l: 4 }",
                },
              ],
              attrs: {
                label: this.$t(
                  "operationalData.entryView.tabs.qualityLossesTab.percentages.opExternal"
                ),
              },
            },
            [
              _c("custom-input", {
                attrs: {
                  id: "customInputOpExternal",
                  "is-disabled": _vm.isReadOnly,
                  required: false,
                  min: 0,
                  max: 100,
                  precision: _vm.qualityLossesPrecision,
                },
                on: {
                  change: function ($event) {
                    return _vm.atInputChangePct(_vm.qualityLossesPct)
                  },
                },
                model: {
                  value: _vm.qualityLossesPct.valueExternal,
                  callback: function ($$v) {
                    _vm.$set(_vm.qualityLossesPct, "valueExternal", $$v)
                  },
                  expression: "qualityLossesPct.valueExternal",
                },
              }),
              _c("pui-form-textarea", {
                staticClass: "mt-1",
                attrs: {
                  id: "customCommentExternal",
                  "is-readonly": false,
                  "is-disabled": _vm.isReadOnly,
                  "max-length": _vm.maxInputLength,
                  grow: false,
                  rows: 8,
                },
                on: {
                  input: function ($event) {
                    return _vm.atInputChangePct(_vm.qualityLossesPct)
                  },
                },
                model: {
                  value: _vm.qualityLossesPct.commentExternal,
                  callback: function ($$v) {
                    _vm.$set(_vm.qualityLossesPct, "commentExternal", $$v)
                  },
                  expression: "qualityLossesPct.commentExternal",
                },
              }),
              _c("div", { staticClass: "right" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.commentLength(this.qualityLossesPct.commentExternal)
                    ) +
                    "/250 "
                ),
              ]),
            ],
            1
          ),
          _c(
            "pui-form-group",
            {
              directives: [
                {
                  name: "pui-form-grid-column",
                  rawName: "v-pui-form-grid-column",
                  value: { s: 12, l: 4 },
                  expression: "{ s: 12, l: 4 }",
                },
              ],
              attrs: {
                label: this.$t(
                  "operationalData.entryView.tabs.qualityLossesTab.percentages.other"
                ),
              },
            },
            [
              _c("custom-input", {
                attrs: {
                  id: "customInputOther",
                  "is-disabled": _vm.isReadOnly,
                  min: 0,
                  max: 100,
                  required: false,
                  precision: _vm.qualityLossesPrecision,
                },
                on: {
                  change: function ($event) {
                    return _vm.atInputChangePct(_vm.qualityLossesPct)
                  },
                },
                model: {
                  value: _vm.qualityLossesPct.valueOther,
                  callback: function ($$v) {
                    _vm.$set(_vm.qualityLossesPct, "valueOther", $$v)
                  },
                  expression: "qualityLossesPct.valueOther",
                },
              }),
              _c("pui-form-textarea", {
                staticClass: "mt-1",
                attrs: {
                  id: "customCommentOther",
                  "is-readonly": false,
                  "is-disabled": _vm.isReadOnly,
                  "max-length": _vm.maxInputLength,
                  grow: false,
                  rows: 8,
                },
                on: {
                  input: function ($event) {
                    return _vm.atInputChangePct(_vm.qualityLossesPct)
                  },
                },
                model: {
                  value: _vm.qualityLossesPct.commentOther,
                  callback: function ($$v) {
                    _vm.$set(_vm.qualityLossesPct, "commentOther", $$v)
                  },
                  expression: "qualityLossesPct.commentOther",
                },
              }),
              _c("div", { staticClass: "right" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.commentLength(this.qualityLossesPct.commentOther)
                    ) +
                    "/250 "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          attrs: {
            title: _vm.$t(
              "operationalData.entryView.tabs.qualityLossesTab.tooltipPrevMonth"
            ),
          },
        },
        [
          _c(
            "pui-button",
            {
              staticClass: "mr-2 mb-2 mt-1",
              staticStyle: { float: "right" },
              attrs: { state: "secondary" },
              on: {
                click: function ($event) {
                  return _vm.commentButtonClick()
                },
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    this.$t(
                      "operationalData.entryView.tabs.qualityLossesTab.btnPrevMonth"
                    )
                  ) +
                  " "
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "pui-form-group",
        {
          directives: [
            {
              name: "pui-form-grid-column",
              rawName: "v-pui-form-grid-column",
              value: { s: 12, l: 4 },
              expression: "{ s: 12, l: 4 }",
            },
          ],
          attrs: {
            label: this.$t(
              "operationalData.entryView.tabs.qualityLossesTab.percentages.sum"
            ),
            "has-info-layer": true,
            "pui-popover-config": {
              headline: this.$t(
                "operationalData.entryView.tabs.qualityLossesTab.tooltipSum.header"
              ).toString(),
              position: "bottom",
            },
          },
        },
        [
          _c(
            "p",
            {
              attrs: { slot: "pui-popover-content" },
              slot: "pui-popover-content",
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    this.$t(
                      "operationalData.entryView.tabs.qualityLossesTab.tooltipSum.text"
                    ).toString()
                  ) +
                  " "
              ),
            ]
          ),
          _c("pui-form-textarea", {
            attrs: {
              id: "customInputSum",
              value: _vm.sum ? _vm.sum.toString() : undefined,
              "is-readonly": true,
              "is-disabled": true,
              "is-valid": isNaN(_vm.sum) || _vm.sum <= 100,
              rows: 1,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }